import * as React from "react";
import { UserMessage } from "./userMessageTypes";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import { DateTimePicker } from "material-ui-pickers";
import { fromMoment, toMoment } from "app/utils/filters";
import * as moment from "moment";

type Props = {
  userMessage: UserMessage;
  onClose: Function;
  extendUserMessageExpiry: any;
};

type State = {
  extending: boolean;
  expireValue: string | null;
};

class ExtendExpiryModal extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      extending: false,
      expireValue: props.userMessage ? props.userMessage.expires_at : null
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    if (
      !!nextProps.userMessage &&
      this.props.userMessage !== nextProps.userMessage
    ) {
      this.setState({ expireValue: nextProps.userMessage.expires_at });
    }
  }

  onExtend = (): void => {
    this.setState({ extending: true });
    this.props
      .extendUserMessageExpiry({
        variables: {
          id: this.props.userMessage.id,
          expires_at: this.state.expireValue
        }
      })
      .then(() => this.props.onClose({ refetchData: true }))
      .catch(alert)
      .finally(() => this.setState({ extending: false }));
  };

  render() {
    return (
      <Dialog
        open={this.props.userMessage != null}
        onClose={() => this.props.onClose()}
      >
        <DialogTitle>{"Extend User Message Expiry Date"}</DialogTitle>
        <DialogContent>
          <DialogContentText>New Expiry Date:</DialogContentText>
          <DateTimePicker
            autoOk={true}
            ampm={false}
            showTodayButton={true}
            fullWidth={true}
            invalidLabel="Please enter date"
            value={
              this.state.expireValue
                ? toMoment(this.state.expireValue)
                : moment()
            }
            onChange={momentEvent =>
              this.setState({ expireValue: fromMoment(momentEvent) })
            }
          />
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={() => this.props.onClose()}>
            Cancel
          </Button>
          <Button
            disabled={this.state.extending}
            color="primary"
            onClick={this.onExtend}
          >
            {this.state.extending ? "Editing..." : "Edit"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const extendUserMessageExpiry = graphql<Props, any, any>(
  gql`
    mutation extendUserMessageExpiry($id: ID!, $expires_at: String!) {
      extend_user_message_expiry(id: $id, expires_at: $expires_at) {
        id
      }
    }
  `,
  { name: "extendUserMessageExpiry" }
);

export default compose(extendUserMessageExpiry)(ExtendExpiryModal);
